import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  card: {
    // minWidth: 210,
    borderRadius: 5,
    boxShadow: '2px 2px 10px 0 rgba(0, 0, 0, 0.2)',
    backgroundColor: '#303030',
  },
  header: {
    height: 33,
    backgroundColor: '#007fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 15px',
    fontSize: 13,
    color: '#fff',
  },

  content: {
    padding: '30px 20px',
  },
  flex: {
    display: 'flex',
    alignItems: 'flex-end',
  },
  hr: {
    height: 1,
    backgroundColor: '#9f9f9f',
    borderRadius: 2,
    margin: '10px 0 5px 0',
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontSize: 10,
    fontFamily: 'Averta Light',
    lineHeight: 1.5,
    color: '#fff',
    fontWeight: 300,
  },
  but: {
    width: 80,
    height: 25,
    fontSize: 9,
    fontFamily: 'Averta Bold',
    lineHeight: 1.2,
    color: '#fff',
    fontWeight: 600,
    backgroundColor: '#007fff',
    borderRadius: 5,
    textTransform: 'none',
    '& .MuiButton-endIcon': {
      marginLeft: 4,
      height: 15,
      width: 15,
      objectFit: 'contain',
    },
  },
  stat: {
    fontSize: 11,
    fontFamily: 'Averta Bold',
    textAlign: 'center',
    color: '#fff',
    fontWeight: 600,
  },
  statText: {
    lineHeight: 1.5,
    fontSize: 11,
    fontFamily: 'Averta light',
    color: '#007fff',
    fontWeight: 300,
  },
  numText: {
    lineHeight: 1.2,
    fontSize: 14,
    fontFamily: 'Averta Bold',
    color: '#007fff',
    fontWeight: 600,
  },
  but2: {
    backgroundColor: '#e4464b',
  },
  bigText: {
    fontSize: 30,
    fontFamily: 'Averta Bold',
    fontWeight: 800,
    lineHeight: 1,
    marginRight: 3,
  },

  text: {
    lineHeight: 1.5,
    fontSize: 10,
    fontFamily: 'Averta light',
    textAlign: 'center',
    color: '#fff',
    fontWeight: 300,
  },
  margin: {
    marginBottom: 15,
  },
  bold: {
    fontFamily: 'Averta Bold',
    fontWeight: 'bold',
  },

  light: {
    fontFamily: 'Averta light',
    fontWeight: 300,
  },
  avatar: {
    height: 35,
    width: 35,
  },

  icon: {
    height: 20,
    width: 20,
    fill: '#f8b100',
    margin: '0 5px',
  },
  light2: {
    height: 12,
    fontFamily: 'Averta Light',
    fontWeight: 300,
    color: '#fff',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '75%',
  },
  row2: {
    display: 'flex',
    alignItems: 'center',
  },
}));
